import { useSelector } from 'react-redux'
import PaymentForm from "./PaymentForm";
import ModalIframe from "../components/ModalIframe";
import { selectNextAction } from '../app/reducers/paymentMethod'
import { selectList } from '../app/reducers/methodsList'
import { selectChallengeURL, selectChallengeInProgress } from '../app/reducers/authentication';

export default function PaymentMethod({ method, methodChoosed, showResult }) {
    const nextAction = useSelector(selectNextAction);
    const methodsList = useSelector(selectList);
    const challengeURL = useSelector(selectChallengeURL);
    const challengeInProgress = useSelector(selectChallengeInProgress);

    function buildWrapperClassName() {
        return "payment-method-wrapper " + method.id + " " + (methodChoosed ? " selected" : "")
    }

    if (!methodChoosed) return null;
    return (
        <div className={buildWrapperClassName()}>

        {methodChoosed && nextAction!=undefined && nextAction.type=="open_iframe_modal" && <ModalIframe url={nextAction.data.url} />}
        {methodChoosed && challengeInProgress && <ModalIframe url={challengeURL} />}

      {methodChoosed &&
      <div className={"payment-method-form-wrapper"+((methodsList.length>1)?"":" payment-method-form-single")}>
        <div className={"payment-method-form-content"+(showResult ? " is-result" : "")}>
          <PaymentForm showResult={showResult} />
        </div>
      </div>}
    </div>
    )
}
